import { GeneralShift, IndividualShift } from "@/actions/schedule/interfaceSchedule";
import { generateUUID } from "./GenerateUUID";

interface Event {
    id: string;
    title: string | undefined;
    daysOfWeek: number[] | string[];
    startTime: string;
    endTime: string;
    startRecur: string;
    endRecur: string;
}


export const generateDailyEvents4 = (data: IndividualShift[]) => {

    const events: Event[] = [];
    data.forEach(element => {
        events.push({
            id: String(element.id),
            title: element.shift || "E",
            daysOfWeek: [element.day], // Repite en este día de la semana
            startTime: element.startTime,
            endTime: element.endTime,
            startRecur: '2024-01-01', // Fecha de inicio de la recurrencia
            endRecur: '2099-12-31' // Fecha de fin de la recurrencia
        });
    });
    return events;
}

export const generateDailyEvents = (data: GeneralShift, daysActive: number[]) => {

    const events: Event[] = [];
    const { startTime, endTime, id, shift } = data;

    daysActive.forEach(day => {
        events.push({
            id: generateUUID(),
            title: shift,
            daysOfWeek: [day], // Repite en este día de la semana
            startTime: startTime,
            endTime: endTime,
            startRecur: '2024-01-01', // Fecha de inicio de la recurrencia
            endRecur: '2099-12-31' // Fecha de fin de la recurrencia
        });
    });

    return events;
};
